import { Youtube, ArrowUpRight } from "lucide-react";
import { CHANNEL_URL } from "@/constants/roles";

export const AboutSection = () => {
  return (
    <section id="about" className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <div className="relative order-2 lg:order-1">
            <div className="overflow-hidden rounded-3xl shadow-2xl shadow-slate-900/10">
              <img
                data-testid="about-image"
                src="https://images.unsplash.com/photo-1627244714766-94dab62ed964?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw3fHx5b3V0dWJlJTIwdmlkZW8lMjBwcm9kdWN0aW9uJTIwZWRpdGluZyUyMGRlc2t8ZW58MHx8fHwxNzg4NjkwNTMwfDA&ixlib=rb-4.1.0&q=85"
                alt="ItsMelto studio production desk"
                className="h-80 w-full object-cover sm:h-96"
              />
            </div>
            <div className="absolute -bottom-5 left-6 rounded-2xl border border-slate-200/60 bg-white/90 px-5 py-3 shadow-lg backdrop-blur-lg">
              <p className="font-mono-label text-[10px] font-bold uppercase tracking-widest text-cyan-600">Focus</p>
              <p className="font-display text-sm font-bold text-slate-900">Roblox story shorts · 30–40s</p>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <p className="font-mono-label text-xs font-bold uppercase tracking-widest text-cyan-600">The channel</p>
            <h2 data-testid="about-heading" className="mt-4 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl md:text-4xl">
              What is <span className="text-cyan-500">@ItsMelto</span>?
            </h2>
            <p className="mt-6 text-base leading-relaxed text-slate-600">
              ItsMelto is a Roblox animation channel built around cinematic, blocky storytelling — expressive
              characters, punchy edits, and stories that keep viewers watching to the last frame.
            </p>
            <p className="mt-4 text-base leading-relaxed text-slate-600">
              We're growing from a one-person studio into a small paid crew. If you love Roblox, animation, and
              YouTube pacing, this is your chance to shape a channel from the inside.
            </p>
            <a
              data-testid="about-channel-link"
              href={CHANNEL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-slate-800"
            >
              <Youtube className="h-4 w-4 text-cyan-400" />
              youtube.com/@ItsMelto
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
